// 请求
class Requests {
	constructor() {
		const that = this
		this.http = "https://admin.tiktokshopcc.top/"
		this.img_url="https://admin.tiktokshopcc.top/"
		this.num = 0
		this.request = (url, method, data, load) => {
		    that.num++;
		    if (!load) {
		        // uni.showLoading({
		        //     title: ""
		        // });
		    }
		    let lang = uni.getStorageSync('lang');
		    return new Promise((resolve, reject) => {
		        try {
		            if (url != '' && url != undefined && url != null) {
		                // 检查是否为 FormData 格式
		                let headers = {};
		                if (data instanceof FormData) {
		                    // 如果是 FormData，不手动设置 Content-Type，让浏览器自动处理
		                    headers = {
		                        'Content-Type': 'multipart/form-data',
		                    };
		                } else {
		                    // 普通 JSON 或表单数据
		                    headers = {
		                        'Content-Type': 'application/x-www-form-urlencoded',
		                    };
		                    data = { ...data }; // 普通对象直接传递
		                }
		
		                uni.request({
		                    url: `${that.http}/index/${url}?lang=${lang}`,
		                    method: method,
		                    data: data,
		                    header: headers, // 根据 data 类型设置 headers
		                    success(res) {
		                        resolve(res);
		                    },
		                    fail(err) {
		                        uni.showToast({
		                            title: 'err',
		                            icon: 'none'
		                        });
		                        reject(err);
		                    },
		                    complete() {
		                        that.num--;
		                        if (that.num == 0) {
		                            uni.hideLoading();
		                        }
		                    }
		                });
		            } else {
		                that.num--;
		                if (that.num == 0) {
		                    uni.hideLoading();
		                }
		                console.log('无效地址');
		            }
		        } catch (err) {
		            reject(err);
		        }
		    });
		}

	}
	// get请求
	get(url, data, load) {
		return this.request(url, 'GET', data, load)
	}
	// post请求
	post(url, data, load) {
		return this.request(url, 'POST', data, load)
	}
	
}
const requests = new Requests();
export default requests
